// src/app/language.service.ts
import { Injectable, NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject  } from 'rxjs';
import { map } from 'rxjs/operators';

interface Translations {
  [key: string]: string;
}

@Injectable({
  providedIn: 'root'
})

export class LanguageService {
  private readonly storageKey = 'activeLanguage';
  private defaultLanguage = 'mr';
  private translations: BehaviorSubject<Translations> = new BehaviorSubject<Translations>({});
  private _languageSubject: BehaviorSubject<string>;
  public language$: Observable<string>;
 private _currentLanguage = new BehaviorSubject<string>('मराठी');
  currentLanguage$ = this._currentLanguage.asObservable();
  private observer: MutationObserver;
  constructor(private http: HttpClient,private ngZone: NgZone) {
       // this.initLanguageDetection();
    // const storedValue = sessionStorage.getItem(this.storageKey);
    // const initialLanguage = storedValue !== null ? storedValue : this.defaultLanguage;
    // this._languageSubject = new BehaviorSubject<string>(initialLanguage);
    // this.language$ = this._languageSubject.asObservable();
    // this.loadTranslations(initialLanguage);
     // sessionStorage.setItem(this.storageKey, this.defaultLanguage);
    const storedValue = sessionStorage.getItem(this.storageKey);

if (!storedValue) {
  sessionStorage.setItem(this.storageKey, this.defaultLanguage);
}

const initialLanguage = storedValue || this.defaultLanguage;

this._languageSubject = new BehaviorSubject<string>(initialLanguage);
this.language$ = this._languageSubject.asObservable();
this.loadTranslations(initialLanguage);
  }

  private loadTranslations(lang: string): void {
    this.http.get<Translations>(`./assets/data/lang/${lang}.json`).subscribe(
      translations => this.translations.next(translations),
      error => console.error(`Could not load translations for ${lang}:`, error)
    );
  }

  public get currentLanguage(): string {
    return this._languageSubject.value;
  }

  public set currentLanguage(language: string) {
    sessionStorage.setItem(this.storageKey, language);
    this.loadTranslations(language);
    this._languageSubject.next(language);
  }

  public changeLanguage(language: string) {
    this.currentLanguage = language;
  }

  public getTranslation(key: string): Observable<string> {
    return this.translations.asObservable().pipe(
      map(translations => translations[key] || key)
    );
  }

  public getTranslationSync(key: string): string {
    const translations = this.translations.getValue();
    return translations[key] || key;
  }
//   loadScript(): Promise<void> {
//     return new Promise((resolve, reject) => {
//       if (document.querySelector('script[src*="website_translation_utility.js"]')) {
//         resolve();
//         return;
//       }

//       const script = document.createElement('script');
//       script.src = '';
//       script.async = true;
//       script.setAttribute('language-icon-color', '#fff');
//       script.onload = () => resolve();
//       script.onerror = () => reject(new Error('Failed to load Bhashini script'));
//       document.body.appendChild(script);
//     });
//   }

//  private initLanguageDetection() {
//     // Check initially
//     this.detectLanguage();

//     // Set up MutationObserver to watch for button text changes
//     const dropdownBtn = document.querySelector('.bhashini-dropdown-btn');
    
//     if (dropdownBtn) {
//       this.observer = new MutationObserver((mutations) => {
//         this.detectLanguage();
//       });

//       this.observer.observe(dropdownBtn, {
//         childList: true,
//         subtree: true,
//         characterData: true
//       });
//     }

//     // Fallback: Check every second
//     setInterval(() => this.detectLanguage(), 1000);
//   }

//   private detectLanguage() {
//     const btn = document.querySelector('.bhashini-dropdown-btn');
//     if (!btn) return;

//     // Get text content excluding the SVG icon
//     const lang = Array.from(btn.childNodes)
//       .filter(node => node.nodeType === Node.TEXT_NODE)
//       .map(node => node.textContent?.trim())
//       .join('')
//       .replace('▼', '') // Remove dropdown arrow if present
//       .trim();

//     if (lang && lang !== this._currentLanguage.value) {
//       this.ngZone.run(() => {
//         this._currentLanguage.next(lang || 'English');
//       });
//     }
//   }

//   private detectLanguageFromDOM(): string {
//     // Try different possible selectors (adjust based on Bhashini's DOM structure)
//     return (
//       // Check localStorage first (most reliable)
//       sessionStorage.getItem('bhashini-language') ||
//       // Fallback to DOM inspection
//       document.querySelector('.bhashini-plugin-container [aria-label]')?.getAttribute('aria-label') ||
//       document.querySelector('.bhashini-plugin-container .selected-language')?.textContent?.trim() ||
//       'English' // Default fallback
//     );
//   }

//   private updateLanguage(lang: string) {
//     this.ngZone.run(() => {
//       this._currentLanguage.next(lang);
//     });
//   }

    private scrollSource = new Subject<string>();
      scroll$ = this.scrollSource.asObservable();

      scrollTo(sectionId: string) {
        this.scrollSource.next(sectionId);
      }
}
